import { useEffect, useState } from "react";

function format(d: Date): string {
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  const cs = String(Math.floor(d.getMilliseconds() / 10)).padStart(2, "0");
  return `${h}:${m}:${s}:${cs}`;
}

export function useLiveTimecode(intervalMs = 40): string {
  const [value, setValue] = useState(() => format(new Date()));

  useEffect(() => {
    const id = setInterval(() => {
      setValue(format(new Date()));
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return value;
}
